<template>
    <div style="padding-left: 75px; padding-right: 75px; padding-top: 25px;">
        <div class="row" v-if="inspection.company_name && !edited">
            <div class="col s3">
                <a style="margin: 15px;" class="waves-effect waves-light btn-large emptygreen" :href="'#/customers/'+this.$route.params.customer_id+'/places/'+this.$route.params.place_id+'/inspections/'+this.$route.params.inspection_id +'/summary'" v-if="inspection.editable">{{$t('menu.buttons.show_summary')}} <i data-v-2a5bcde8="" class="material-icons right" style="line-height: inherit;">equalizer</i></a>
            </div>
            <div class="col offset-s6 s3 offset-l5 l4" style="display: inline-flex;">
              
                <a v-if="inspection.v3" style="margin: 15px;" class="btn btn-small green" :href="'/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inspections/' + this.$route.params.inspection_id + '/v2.pdf'"><i class="material-icons right">print</i>{{$t('menu.buttons.print')}}</a>
                <a v-else style="margin: 15px;" class="btn btn-small green" :href="'/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inspections/' + this.$route.params.inspection_id + '.pdf'"><i class="material-icons right">print</i>{{$t('menu.buttons.print')}}</a>
                  <a style="margin: 15px;" class="waves-effect waves-light btn-large emptygreen" :href="'#/customers/'+this.$route.params.customer_id+'/places/'+this.$route.params.place_id+'/inspections/'+this.$route.params.inspection_id +'/edit'" v-if="inspection.editable">{{$t('menu.buttons.edit')}}</a>
                <modal v-if="inspection.removable" :question="$t('inspection.remove_question')" :confirmText="$t('menu.buttons.delete')" identifier="inspectionRemoveQuestion" v-on:onConfirm="removeInspection(inspection)" />
            </div>
        </div>
        <div v-if="loaded && inspection.v3">
            <div class="row" style="padding-top: 20px;">
                <div class="col s6">
                    <h4>{{$t('inspection.title')}}</h4>
                </div>
                <div class="col s6" style=" display: table-cell; vertical-align: middle; ">
                    <h5 style="line-height: 160%;">{{$t('inspection.date')}}: {{inspection.date | formatDate}}</h5>
                </div>
            </div>
            <div class="row">
                <div class="col s12">
                    <table class="addresses">
                        <tr>
                            <th width="50%" style="text-transform: uppercase;">{{$t('inspection.company')}}</th>
                            <th width="50%" style="text-transform: uppercase;">{{$t('inspection.place_name')}}</th>
                        </tr>
                        <tr>
                            <td>
                                {{inspection.company_name}}<br />
                                {{inspection.company_address.street}}<br />
                                {{inspection.company_address.postal_code}} {{inspection.company_address.city}}
                            </td>
                            <td>
                                {{inspection.place_name}}<br />
                                {{inspection.place_address.street}}<br />
                                {{inspection.place_address.postal_code}} {{inspection.place_address.city}}
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col s6" style="padding-top: 5px;">
                    {{$t('inspection.inspector')}}: {{inspection.worker}}
                </div>
            </div>
            <div class="row">
                <div class="col s12" style="display: inline-flex;">
                    <h6><b>{{$t('inspection.sanitary_assesment')}}: </b></h6>
                    <p style="padding-left: 15px;">
                        <template v-if="inspection.conditions == 1 && inspection.answers_yes == false && unresolved_recommendations.length == 0">
                            {{$t('inspection.without_notions')}}
                        </template>
                        <template v-else>
                            {{$t('inspection.with_notions')}}
                        </template>
                    </p>
                </div>
            </div>
            <div class="row">
                <div class="col s12" style="padding-bottom: 15px;">
                    <template v-if="inspection.conditions == 1  || inspection.answers_yes">
                        {{$t('inspection.more_on_sanitary_conditions')}}
                    </template>
                </div>
            </div>
            <div class="row">
                <div class="col s12">
                    <h6><b>{{$t('inspection.pests_activity_outside')}}</b></h6>
                </div>
            </div>
            <div class="row">
                <div class="col s12">
                    {{$t('inspection.activity')}}: <b>{{act_levels[inspection.safety_conditions]}}</b>
                </div>
            </div>
            <div class="row" v-for="pest in inspection.inspection_pests">
                <div class="col s3" v-if="pest.pest_name != null">
                    {{$t('inspection.pest')}}: <b>{{pest.pest_name}}</b>
                </div>
                <div class="col s3" v-else>
                    {{$t('inspection.pest')}}: <b>{{pest.other}}</b>
                </div>
                <div class="col s9">
                    {{$t('inspection.comments_location')}}: {{pest.notices}}
                </div>
            </div>
            <div style="height: 25px;" />
            <div class="row">
                <div class="col s2" v-for="photo in inspection.pests_photos">
                    <div style="width: fit-content; margin: auto;"><img :src="photo.image_thumb" /></div>
                    <p>{{photo.notices}}</p>
                </div>
            </div>
            <div class="row">
                <div class="col s6">
                    <h6><b>{{$t('inspection.inspection_scope')}}</b></h6>
                </div>
            </div>
            <template v-for="items, zone in groups">
                <div class="row" v-if="zone != null && zone !='null' ">
                    <div class="col s12">
                        <p style="font-size: 17px;">{{$t('inspection.zone')}}: {{zone}}</p>
                    </div>
                </div>
                <div class="row">
                    <div class="col s12">
                        <table>
                            <tr>
                                <th style="width: 40%;">{{$t('inspection.device_category')}}</th>
                                <th style="width: 8%">{{$t('inspection.quantity')}}</th>
                                <th style="width: 15%; text-transform: uppercase;">{{$t('inspection.activity')}}</th>
                                <th>{{$t('inspection.substances_materials')}}</th>
                            </tr>
                            <tr v-for="row in items">
                                <td>{{row.dev_type_name}}</td>
                                <td>{{row.total || 0}} z {{row.out_of}}</td>
                                <td>{{act_levels[row.avg]}}</td>
                                <td>
                                    <template v-for="(substance, index) in row.substances">
                                        <substancepopup :substance="substance"/>{{index == row.substances.length - 1 ? "" : ", "}}
                                    </template>
                                </td>
                            </tr>
                        </table>
                    </div>
                </div>
            </template>
            <div style="height: 25px;" />
            <div class="row">
                <div class="col s12">
                    <h6><b>{{$t('inspection.exceeds')}}</b></h6>
                </div>
            </div>
            <div class="row exceedvalues">
                <div class="col s5">
                    {{$t('inspection.device_category')}} / {{$t('inspection.zone')}}:
                </div>
                <div class="col s7" >
                    <template v-for="(ez, index) in inspection.exceeded_zones" v-if="inspection.exceeded_zones.length > 0">
                        <template v-if="index != 0"><br/></template>
                        <b>{{ez[0].name}}<template v-if="ez[1] != null"> / {{ez[1].name}}</template></b>
                        <b v-if='ez[1] == null'> / {{$t('inspection.no_zone_assigned')}}</b>
                    </template>
                    <template v-if="inspection.exceeded_zones.length == 0">brak</template>
                </div>
                <div class="col s5" v-if="zones_pests_critical.length > 0">
                    {{$t('inspection.device_category')}} / {{$t('inspection.zone')}} / {{$t('inspection.pest')}}:
                </div>
                <div class="col s7" v-if="zones_pests_critical.length > 0">
                    <template v-for="(zpc, gindex) in zones_pests_critical">
                        <template v-if="gindex != 0"><br/></template>
                        <template v-if="zpc.kind == 'anyof'" v-for="(anyof, index) in zpc.items">
                             <template v-if="index != 0"><br/></template>
                            <b>
                                {{anyof[0]}}
                            </b>
                        </template>
                        <template v-if="zpc.kind == 'avg'" v-for="(anyof, index) in zpc.items">
                             <template v-if="index != 0"><br/></template>
                            <b>
                                {{anyof[0]}}
                            </b>
                        </template>
                        <template v-if="zpc.kind == 'max'" v-for="(max, index) in zpc.items">
                             <template v-if="index != 0"><br/></template>
                            <b>
                                {{max[0]}} (<template v-for="(dn, index) in max[1]"><template v-if="index > 0">, </template>{{dn[3]}}</template>)
                            </b>
                        </template>
                        <template v-if="zpc.kind == 'med'" v-for="(anyof, index) in zpc.items">
                             <template v-if="index != 0"><br/></template>
                            <b>
                                {{anyof[0]}}
                            </b>
                        </template>
                    </template>
                </div>
                <div class="col s12" v-if=" zones_pest_anyofs_disaster.length > 0">
                    {{$t('inspection.disaster_reached')}} {{$t('inspection.device_category')}} / {{$t('inspection.zone')}} / {{$t('inspection.pest')}} (dla każdego punktu monitorowania):
                    <template v-for="(anyof, index) in zones_pest_anyofs_disaster">
                        <template v-if="index != 0">, </template>
                        <b>
                            {{anyof[0]}}
                        </b>
                    </template>
                </div>
                <div class="col s12" v-if="zones_pest_avgs_disaster.length > 0">
                    {{$t('inspection.disaster_reached')}} {{$t('inspection.device_category')}} / {{$t('inspection.zone')}} / {{$t('inspection.pest')}} (średnia):
                    <template v-for="(avg, index) in zones_pest_avgs_disaster">
                        <template v-if="index != 0">, </template>
                        <b>
                            {{avg[0]}}
                        </b>
                    </template>
                </div>
                <div class="col s12" v-if="zones_pest_maxes_disaster.length > 0">
                    {{$t('inspection.disaster_reached')}} {{$t('inspection.device_category')}} / {{$t('inspection.zone')}} / {{$t('inspection.pest')}} (wartości maksymalne):
                    <template v-for="(max, index) in zones_pest_maxes_disaster">
                        <template v-if="index != 0">, </template>
                        <b>
                            {{max[0]}} (<template v-for="(dn, index) in max[1]"><template v-if="index > 0">, </template>{{dn[3]}}</template>)
                        </b>
                    </template>
                </div>
                <div class="col s12" v-if="zones_pest_meds_disaster.length > 0">
                    {{$t('inspection.disaster_reached')}} {{$t('inspection.device_category')}} / {{$t('inspection.zone')}} / {{$t('inspection.pest')}} (mediana):
                    <template v-for="(median, index) in zones_pest_meds_disaster">
                        <template v-if="index != 0">, </template>
                        <b>
                            {{median[0]}}
                        </b>
                    </template>
                </div>
            </div>
            <div style="height: 25px;" />
            <div class="row">
                <div class="col s12">
                    <h6><b>{{$t('inspection.inspection_title')}}</b></h6>
                </div>
            </div>
            <template v-for="properties_casting, gname in property_groups">
                <div class="row" v-if="gname != null && gname !='null' ">
                    <div class="col s4" style="padding-top: 15px;padding-left: 0px;">
                        <h6>
                            <p>{{$t('inspection.zone')}}: {{gname}}</p>
                        </h6>
                        <hr />
                    </div>
                </div>
                <template v-for='pc in properties_casting'>
                    <div class="row">
                        <div class="col s6" style="padding-top: 15px;">
                            <b>{{pc.device_category.name}}</b>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s6">
                            {{$t('inspection.previous_inspection')}}
                        </div>
                        <div class="col s6">
                            {{$t('inspection.current_inspection')}}
                        </div>
                    </div>
                    <div class="row">
                        <div class="col s12">
                            <table class="properties">
                                <thead>
                                    <tr>
                                        <th>{{$t('inspection.number')}}.</th>
                                        <th style="width: 7%">{{$t('inspection.date_time')}}</th>
                                        <template v-if="pc.previous_method == 'standard'">
                                            <th>{{$t('inspection.pests_activity')}}</th>
                                            <th style="width: 10%; text-transform: uppercase;">{{$t('inspection.pests')}}</th>
                                        </template>
                                        <template v-if="pc.previous_method == 'pests_quantity'">
                                            <th style="width: 20%" colspan="2">{{$t('inspection.pests_quantities')}}</th>
                                        </template>
                                        <template v-if="pc.previous_method == 'substance_consumed'">
                                            <th>{{$t('devices.substance_consumed')}}</th>
                                            <th style="width: 10%; text-transform: uppercase;">{{$t('inspection.pests')}}</th>
                                        </template>
                                        <template v-if="pc.previous_method == 'logic_value'">
                                            <th>{{$t('inspection.catched')}}</th>
                                            <th style="width: 10%; text-transform: uppercase;">{{$t('inspection.pests')}}</th>
                                        </template>
                                        <th style="width: 20%">{{$t('inspections.notices')}}</th>
                                        <th style="border-left: 2px solid; width: 7%; border-top: 2px solid black;">{{$t('inspection.date_time')}}</th>
                                        <template v-if="pc.current_method == 'standard'">
                                            <th style="border-top: 2px solid black;">{{$t('inspection.pests_activity')}}</th>
                                            <th style="width: 10%; border-top: 2px solid black; text-transform: uppercase;">{{$t('inspection.pests')}}</th>
                                        </template>
                                        <template v-if="pc.current_method == 'pests_quantity'">
                                            <th style="width: 20%; border-top: 2px solid black;" colspan="2">{{$t('inspection.pests_quantities')}}</th>
                                        </template>
                                        <template v-if="pc.current_method == 'substance_consumed'">
                                            <th style="border-top: 2px solid black;">{{$t('devices.substance_consumed')}}</th>
                                            <th style="width: 10%; border-top: 2px solid black; text-transform: uppercase;">{{$t('inspection.pests')}}</th>
                                        </template>
                                        <template v-if="pc.current_method == 'logic_value'">
                                            <th style="border-top: 2px solid black;">{{$t('inspection.catched')}}</th>
                                            <th style="width: 10%;border-top: 2px solid black; text-transform: uppercase;">{{$t('inspection.pests')}}</th>
                                        </template>
                                        <th style="border-top: 2px solid black;">{{$t('inspection.cleanup')}}</th>
                                        <th style="border-top: 2px solid black;">{{$t('inspection.substance_replaced')}}</th>
                                        <th style="width: 20%; border-top: 2px solid black;">{{$t('inspections.notices')}}</th>
                                        <th style="border-left: 2px solid; border-top: 2px solid black; border-right: 2px solid black;">{{$t('inspection.trend')}}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in pc.items">
                                    <td>{{item.number}}</td>
                                    <template v-if="item.prev_property_id == null">
                                        <template v-if="item.prev_problem_id != null">
                                            <td>{{problem_kinds[item.prev_kind]}}</td>
                                        </template>
                                        <template v-else-if="item.prev_temporary_disabled">
                                            <td>{{$t('inspection.temporary_disabled')}}</td>
                                        </template>
                                        <template v-else>
                                            <td>----</td>
                                        </template>
                                        <template v-if="pc.previous_method == 'pests_quantity'">
                                            <td colspan="2">----</td>
                                        </template>
                                        <template v-else>
                                            <td>----</td>
                                            <td>----</td>
                                        </template>
                                         <template v-if="item.prev_temporary_disabled || item.prev_kind == 6">
                                            <td>{{item.prev_temporary_disabled_cause}}</td>
                                        </template>
                                        <template v-else>
                                            <td style="text-align: left;">{{item.prev_cause}}</td>
                                        </template>
                                    </template>
                                    <template v-else-if="item.prev_license_locked">
                                        <td colspan="6">
                                            {{$t('inspection.license_locked')}}
                                        </td>
                                    </template>
                                    <template v-else>
                                        <td style="white-space: nowrap;">{{item.prev_real_time | formatDateWithHourSeconds}}</td>
                                        <template v-if="pc.previous_method == 'standard'">
                                            <td>{{item.prev_conditions}}</td>
                                            <td style="text-align: left;">{{(item.prev_pests || [""]).join(", ")}}</td>
                                        </template>
                                        <template v-if="pc.previous_method == 'substance_consumed'">
                                            <td>{{item.prev_consumed | format_number}} %</td>
                                            <td style="text-align: left;">{{(item.prev_pests || [""]).join(", ")}}</td>
                                        </template>
                                        <template v-if="pc.previous_method == 'pests_quantity'">
                                            <td colspan="2" style="text-align: left;">
                                                <template v-for="pp in item.prev_property_pests">
                                                    <template v-if="pp.pest_id != null">
                                                        <template v-if="pests_dict[pp.pest_id]">
                                                            <template v-if="zones_devtypes_criteria[pc.zone_id][pc.device_category.id][pp.pest_id] != undefined">
                                                                <b>{{pests_dict[pp.pest_id].name}}</b>
                                                            </template>
                                                            <template v-else>
                                                                {{pests_dict[pp.pest_id].name}}
                                                            </template>
                                                    </template>
                                                    </template>
                                                    <template v-else-if="pp.other != null && pp.other != ''">{{pp.other}}</template>
                                                    <template v-else>{{$t('inspection.to_marking')}}</template> ({{pp.quantity}})
                                                </template>

                                            </td>
                                        </template>
                                        <template v-if="pc.previous_method == 'logic_value'">
                                            <td>
                                                {{item.prev_catched ? $t('inspection.yes') : $t('inspection.no')}}
                                            </td>
                                            <td style="text-align: left;">
                                                {{(item.prev_pests || [""]).join(", ")}}
                                            </td>
                                        </template>
                                        <td style="text-align: left;">
                                            <template v-if="item.prev_safety_conditions == 2"><p>{{$t('inspection.broken')}} ({{item.prev_notions}})
                                              {{item.prev_maintenaces.join(", ")}}</p></template>
                                            <template v-else-if="item.prev_safety_conditions == 1"><p>{{$t('inspection.need_replace')}} ({{item.prev_notions}})
                                              {{item.prev_maintenaces.join(", ")}}</p></template>
                                            <template v-else>
                                                <p>{{item.prev_notions}}
                                                  {{item.prev_maintenaces.join(", ")}}</p>
                                            </template>
                                            <template v-if="item.prev_got_sample"><p>{{$t('inspection.got_to_marking')}}</p></template>
                                            <template v-if="item.prev_replaced">{{$t('inspection.replaced_device')}}</template>
                                        </td>
                                    </template>
                                    <!-- curent -->
                                    <template v-if="item.property_id == null">
                                        <template v-if="item.problem_id != null">
                                            <td class="current" v-bind:class="[index == pc.items.length - 1 ? 'bolded-bottom' : '']">{{problem_kinds[item.kind]}}</td>
                                        </template>
                                        <template v-else-if="item.temporary_disabled">
                                            <td class="current">{{$t('inspection.temporary_disabled')}}</td>
                                        </template>
                                        <template v-else>
                                            <td class="current">----</td>
                                        </template>
                                        <template v-if="pc.current_method == 'pests_quantity'">
                                            <td class="current" colspan="2">----</td>
                                        </template>
                                        <template v-else>
                                            <td class="current">----</td>
                                            <td class="current">----</td>
                                        </template>
                                        <td class="current">----</td>
                                        <td class="current">----</td>
                                        <template v-if="item.temporary_disabled || item.kind == 6">
                                            <td class="current" style="text-align: left;">{{item.temporary_disabled_cause}}</td>
                                        </template>
                                        <template v-else>
                                            <td class="current" style="text-align: left;">{{item.cause}}</td>
                                        </template>
                                        
                                        <td class="current bolded-left bolded-right">----</td>
                                    </template>
                                    <template v-else-if="item.license_locked">
                                        <td class="current" colspan="6">
                                            {{$t('inspection.license_locked')}}
                                        </td>
                                    </template>
                                    <template v-else>
                                        <td class="current" style="white-space: nowrap;">{{item.real_time | formatDateWithHourSeconds}}</td>
                                        <template v-if="pc.current_method == 'standard'">
                                            <td class="current">{{item.conditions}}</td>
                                            <td class="current" style="text-align: left;">{{(item.pests || [""]).join(", ")}}</td>
                                        </template>
                                        <template v-if="pc.current_method == 'substance_consumed'">
                                            <td class="current">{{item.consumed | format_number}} %</td>
                                            <td class="current" style="text-align: left;">{{(item.pests || [""]).join(", ")}}</td>
                                        </template>
                                        <template v-if="pc.current_method == 'pests_quantity'">
                                            <td class="current" colspan="2" style="text-align: left;">
                                                <template v-for="pp in item.property_pests">
                                                    <template v-if="pp.pest_id != null">
                                                        <template v-if="zones_devtypes_criteria[pc.zone_id][pc.device_category.id][pp.pest_id] != undefined">
                                                            <b>{{pests_dict[pp.pest_id].name}}</b>
                                                        </template>
                                                        <template v-else>
                                                            {{pests_dict[pp.pest_id].name}}
                                                        </template>
                                                    </template>
                                                    <template v-else-if="pp.other != null && pp.other != ''">{{pp.other}}</template>
                                                    <template v-else>{{$t('inspection.to_marking')}}</template> ({{pp.quantity}})

                                                </template>
                                            </td>
                                        </template>
                                        <template v-if="pc.current_method == 'logic_value'">
                                            <td class="current">
                                                {{item.catched ? $t('inspection.yes') : $t('inspection.no')}}
                                            </td>
                                            <td class="current" style="text-align: left;">
                                                {{(item.pests || [""]).join(", ")}}
                                            </td>
                                        </template>
                                        <td class="current">
                                            {{item.cleanup ? $t('inspection.yes') : $t('inspection.no')}}
                                        </td>
                                        <td class="current">
                                            {{item.substance_replaced ? $t('inspection.yes') : $t('inspection.no')}}
                                        </td>
                                        <td class="current" style="text-align: left;">
                                           
                                            <template v-if="item.safety_conditions == 2"><p>{{$t('inspection.broken')}} ({{item.notions}})
                                            {{item.maintenaces.join(", ")}}</p></template>
                                            <template v-else-if="item.safety_conditions == 1"><p>{{$t('inspection.need_replace')}} ({{item.notions}})
                                            {{item.maintenaces.join(", ")}}</p></template>
                                            <template v-else><p>{{item.notions}}
                                            {{item.maintenaces.join(", ")}}</p></template>
                                            <template v-if="item.got_sample"><p>{{$t('inspection.got_to_marking')}}</p></template>
                                            <template v-if="item.replaced">{{$t('inspection.replaced_device')}}</template>
                                        </td>
                                        <td class="current bolded-left bolded-right">
                                            <template v-if="item.prev_property_id == null || item.property_id == null || item.prev_license_locked || item.license_locked">
                                                ----
                                            </template>
                                            <template v-else>
                                                <template v-if="item.conditions == item.prev_conditions">
                                                    <font color="gray">●</font>
                                                </template>
                                                <template v-else-if="item.conditions > item.prev_conditions">
                                                    <font color="red">▲</font>
                                                </template>
                                                <template v-else-if="item.conditions < item.prev_conditions">
                                                    <font color="green">▼</font>
                                                </template>
                                                <template v-else>----</template>
                                            </template>
                                        </td>
                                    </template>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </template>
            </template>
            <div class="row">
                <div class="col s6" style="padding-top: 5px;">
                    <b>{{$t('inspection.trends')}}:</b>
                    <font color="red">▲</font> - {{$t('inspection.ascending')}} <font color="gray">●</font> - {{$t('inspection.constant')}} <font color="green">▼</font> - {{$t('inspection.descending')}}
                </div>
            </div>
            <div class="row" style="padding-top: 15px;">
                <div class="col s12">
                    <h6><b>{{$t('inspection.substances_tresholds')}}</b></h6>
                </div>
            </div>
            <template v-for="criterium in inspection.criteria">
                <template v-for="criterium_category in criterium.categories">
                    <div class="row" style="padding-top: 15px;">
                        <template v-if="criterium.zone_name != null">
                            <div class="col s12">{{criterium_category.name}}, {{$t('inspection.zone')}}: {{criterium.zone_name}}</div>
                        </template>
                        <template v-if="criterium.zone_name == null">
                            <div class="col s12">{{criterium_category.name}}, {{$t('inspection.no_zone')}}</div>
                        </template>
                    </div>
                    <criterium :criterium=criterium_category :from_zone="criterium.zone_name != null" :pests="pestslist" :has_disaster_point="criterium.has_disaster_point"></criterium>
                </template>
            </template>
            <template v-if="dosages_assigned && inspection.dosage_table.length > 0">
            <div class="row" style="padding-top: 15px;">
                <div class="col s6">
                    <b>{{$t('inspection.substances_usages')}}</b>
                </div>
            </div>
            <div class="row">
                <div class="col s12">
                    <table>
                        <tr>
                            <th>{{$t('inspection.name')}}</th>
                            <th>{{$t('inspection.amount')}}</th>
                            <th>{{$t('inspection.usage')}}</th>
                            <th>{{$t('inspection.replaced_suplemented')}}</th>
                            <th v-if="new_dosage">{{$t('inspection.new_dosage')}}</th>
                        </tr>
                        <tr v-for="dose in inspection.dosage_table">
                            <td>{{dose.name}}</td>
                            <td>{{dose.applied}} {{dose.unit}}</td>
                            <td>{{dose.consumed==0.0 ? "-------" : dose.consumed}} {{dose.consumed==0.0 ? "" : dose.unit}}</td>
                            <td>{{dose.replaced}} {{dose.unit}}</td>
                            <td v-if="new_dosage">
                                <template v-if="dose.dose_change">{{dose.new_dose}} {{dose.unit}}</template>
                                <template v-else>-------</template>
                            </td>
                        </tr>
                    </table>
                </div>
            </div>
            </template>
            <div class="row" style="padding-top: 30px;">
                <div class="col s6">
                    <b>{{$t('inspection.sanitary_conditions')}}</b>
                </div>
            </div>
            <div class="row">
                <div class="col s12">
                     {{inspection.conditions_notions}}
                    <table>
                        <tr>
                            <th>{{$t('inspection.comments_recommendations')}}:</th>
                            <th></th>
                        </tr>
                        <template v-for="recommendation in inspection.recommendations">
                            <tr v-if="recommendation.status == 'unresolved'">
                                <td>{{recommendation.about}}</td>
                                <td>{{recommendation.solution}}</td>
                            </tr>
                        </template>
                    </table>
                </div>
            </div>
            <div class="row">
                <div class="col s12">
                    {{$t('inspection.full_list_onrecommendations')}}
                </div>
            </div>
            <div class="row" v-if="inspection.answers.length > 0" style="margin-top: 1em;">
                <div class="col s6">
                    <h6>{{$t('inspection.sanitary_questions')}}</h6>
                </div>
            </div>
            <div class="row" v-if="inspection.answers.length > 0" style="padding-bottom: 15px;">
                <div class="col s12">
                    <table>
                        <tr>
                            <th style="width: 50%;">{{$t('inspection.question')}}</th>
                            <th style="width: 50%;">{{$t('inspection.answer')}} </th>
                        </tr>
                        <tr v-for="recommendation in inspection.answers">
                            <td>{{recommendation.question}}</td>
                            <td>{{recommendation.yesno ? $t('inspection.yes') : $t('inspection.no')}}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <div class="row" style="margin-top: 25px;">
                <div class="col s2" v-for="photo in inspection.property_photos">
                    <div style="width: fit-content; margin: auto;"><imagemagnify :image="photo"/></div>
                    <p><b>{{photo.device_number}}</b></p>
                    <p>{{photo.notices}}</p>
                     
                </div>
                <div class="col s2" v-for="photo in inspection.problem_photos">
                    <div style="width: fit-content; margin: auto;"><imagemagnify :image="photo"/></div>
                    <p><b>{{photo.device_number}}</b></p>
                    <p>{{photo.notices}}</p>
                    
                </div>
            </div>
            <div class="row">
                <div class="col s2" v-for="photo in inspection.photos">
                     <div style="width: fit-content; margin: auto;"><imagemagnify :image="photo.image"/></div>
                    <p>{{photo.notices}}</p>
                </div>
            </div>
            <div class="row" v-if="inspection.inner">
                <div class="col s6">
                    <h6><b>{{$t('inspection_procedures.inner_inspections')}}</b></h6>
                </div>
            </div>
            <div class="row" v-if="inspection.inner">
                <div class="col s12">
                    {{$t('inspections.notices')}}: {{inspection.inner_notices}}
                </div>
            </div>
            <div class="row">
                <div class="col s12">{{inspection.additional_pests ? inspection.additional_pests : "-----"}}</div>
            </div>
            <div class="row">
                <div class="col s6" style="padding-left: 15px;">{{$t('inspection.inspected_by')}}: {{inspection.worker}}</div>
                <div class="col s6" style="padding-left: 15px;">{{$t('inspection.accepted_by')}}: {{inspection.acceptor}}</div>
            </div>
            <div class="row">
                <div class="col s6 label">
                    <div style="border: 1px solid black; margin: 5px; margin-right: 15px;">
                        <img v-if="inspection.worker_signature != undefined" style="width: 50%; height: 200px;" :src="`${inspection.worker_signature}`">
                    </div>
                </div>
                <div class="col s6 label">
                    <div v-if="inspection.worker_signature != undefined" style="border: 1px solid black; margin: 5px; margin-right: 15px;"><img style="width: 50%; height: 200px;" :src="`data:image/png;base64,${inspection.signature}`"></div>
                </div>
            </div>
        </div>
        <div v-if="loaded && !(inspection.v3)" style="height: calc(100vh - 200px);">
            <object :data="'/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inspections/' + this.$route.params.inspection_id + '.pdf'" type="application/pdf" width="100%" height="100%">
            </object>
        </div>
        <div v-if="!loaded">
            <div class="container" style="width: 3%; margin: auto;">
                <div class="preloader-wrapper active">
                    <div class="spinner-layer spinner-red-only">
                        <div class="circle-clipper left">
                            <div class="circle"></div>
                        </div>
                        <div class="gap-patch">
                            <div class="circle"></div>
                        </div>
                        <div class="circle-clipper right">
                            <div class="circle"></div>
                        </div>
                    </div>  
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import axios from 'axios';
export default {
    data: function() {
        return {
            inspection: {
                company_address: {},
                place_address: {},
                exceeded_zones: [],
                dosage_table: [],
                answers: [],
            },
            recommendations: [],
            pests: {},
            pestslist: [],
            act_levels: [this.$t('devices.no_activity_short'), this.$t('devices.low_activity_short'), this.$t('devices.average_activity_short'), this.$t('devices.high_activity_short'), this.$t('devices.very_high_activity_short')],
            long_act_levels: [this.$t('devices.no_activity'), this.$t('devices.low_activity'), this.$t('devices.average_activity'), this.$t('devices.high_activity'), this.$t('devices.very_high_activity')],
            problem_kinds: ["", this.$t('inspection.not_found'), this.$t('inspection.unreadable_code'), this.$t('inspection.unavailable'), this.$t('inspection.need_remove'), this.$t('inspection.destroyed'), this.$t('inspection.temporary_disabled')],
            edited: false,
            loaded: false
        }
    },
    props: {},
    created() {
        this.load_inspection();
    },
    methods: {
        async load_inspection() {
            var response = await axios.get('/pests.json');
            this.pests_dict = _.keyBy(response.data, 'id');
            this.pestslist = response.data;
            var response = await axios.get('/customers/' + this.$route.params.customer_id + '/places/' + this.$route.params.place_id + '/inspections/' + this.$route.params.inspection_id + '.json');
            this.inspection = response.data;
            if (this.inspection.worker_signature.indexOf('data:image/png;base64,') == -1) {
                this.inspection.worker_signature = 'data:image/png;base64,' + this.inspection.worker_signature
            }
            for (var pc of this.inspection.properties_casting) {
                pc.items = _.uniqBy(pc.items, 'device_id');
            }
            this.loaded = true;
        },
        zones_groupped(kind) {
            var reachedout = [];
            var reacheds = this.inspection.exceeded_individual_zones;
            for (var i = reacheds.length - 1; i >= 0; i--) {
                var reached = reacheds[i];
                for (var j = reached.pests_quantities.length - 1; j >= 0; j--) {
                    var pt = reached.pests_quantities[j];
                    if (pt.crit_calculation_method == kind) {
                        reachedout.push([reached.device_category_name, reached.zone_name, pt.pest_name, reached.device_number, pt])
                    }
                }

            }
            return _.groupBy(reachedout, function(arr) { return [arr[0], arr[1], arr[2]] });
        },
        removeInspection(inspection) {
            var that = this;
            axios.delete("/customers/" + inspection.customer_id + "/places/" + inspection.place_id + "/inspections/" + inspection.id + ".json").then((response) => {
                that.$router.push({ name: 'inspections' })
            })
        }
    },
    computed: {
        groups() {
            return _.groupBy(this.inspection.summary, 'zone_name')

        },
        property_groups() {
            return _.groupBy(this.inspection.properties_casting, 'zone_name')
        },
        unresolved_recommendations(){
            return _.filter(this.inspection.recommendations, {status: 'unresolved'});
        },
        new_dosage(){
            return !_.isEmpty(_.filter(this.inspection.dosage_table, function(dosage){
                            return dosage.dose_change
                        }));
        },
        dosages_assigned(){
            return _.reject(this.inspection.dosage_table, function(dosage){
                return (dosage.applied == 0 && dosage.new_dose == 0);
            }).length > 0
        },
        zones_devtypes_criteria(){
            var out = {}
            for (var criteriumgroup in this.inspection.criteria){
                var crit = this.inspection.criteria[criteriumgroup];
                out[crit.zone_id] = {};
                for (var catn in crit.categories){
                    var cate = crit.categories[catn];
                    out[crit.zone_id][cate.id] = _.keyBy(cate.pests_thresolds, 'pest_id');
                }
            }
            return out;
        },
        zones_pests_critical(){
            var out = []
            if(this.zones_pest_anyofs_critical.length > 0){
                out.push({kind: 'anyof', items: this.zones_pest_anyofs_critical})
            }
            if(this.zones_pest_avgs_critical.length > 0){
                out.push({kind: 'avg', items: this.zones_pest_avgs_critical})
            }
            if(this.zones_pest_maxes_critical.length > 0){
                out.push({kind: 'max', items: this.zones_pest_maxes_critical})
            }
            if(this.zones_pest_meds_critical.length > 0){
                out.push({kind: 'med', items: this.zones_pest_meds_critical})
            }
            return out;
        },

        zones_pest_anyofs_critical() {
            var reaches = [];
            var reachedout = [];
            if (this.inspection.exceeded_individual_zones != undefined) {
                var groups = this.zones_groupped("anyof")
                var kis = _.keys(groups)
                for (var i = kis.length - 1; i >= 0; i--) {
                    var kij = kis[i];
                    var sumCond = 0;
                    var pg = _.map(groups[kij], _.last);
                    for (var j = pg.length - 1; j >= 0; j--) {
                        sumCond += pg[j].quantity
                    }
                    var pestid = pg[0].pest_id;
                    var pt = _.find(pg[0].thresolds, { pest_id: pestid })
                    if (sumCond < pt.medium_activity_thresold) {
                        sumCond = 1
                    } else if (sumCond < pt.high_activity_thresold) {
                        sumCond = 2
                    } else if (sumCond < pt.very_activity_thresold) {
                        sumCond = 3
                    } else if (sumCond >= pt.medium_activity_thresold) {
                        sumCond = 4
                    }

                    var crit = _.first(pg).critical_point;
                    if (sumCond > crit) {
                        reaches.push(groups[kij]);
                    }
                }
            }
            return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
        },
        zones_pest_anyofs_disaster() {
            var reaches = [];
            var reachedout = [];
            if (this.inspection.exceeded_individual_zones != undefined) {
                var groups = this.zones_groupped("anyof")
                var kis = _.keys(groups)
                for (var i = kis.length - 1; i >= 0; i--) {
                    var kij = kis[i];
                    var pg = _.map(groups[kij], _.last);
                    var conds = _.map(pg, 'conditions')
                    var suma = _.sum(conds);
                    var sumCond = 0;
                    if (sumCond < pg[0].thresolds.medium_activity_thresold) {
                        sumCond = 1
                    } else if (sumCond < pg[0].thresolds.high_activity_thresold) {
                        sumCond = 2
                    } else if (sumCond < pg[0].thresolds.very_activity_thresold) {
                        sumCond = 3
                    } else if (sumCond >= pg[0].thresolds.medium_activity_thresold) {
                        sumCond = 4
                    }
                    var disaster = _.first(pg).disaster_point;
                    if (sumCond > disaster) {
                        reaches.push(groups[kij]);
                    }
                }
            }

            return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
        },
        zones_pest_avgs_critical() {
            var reaches = [];
            var reachedout = [];
            if (this.inspection.exceeded_individual_zones != undefined) {
                var groups = this.zones_groupped("avg");
                var kis = _.keys(groups)
                for (var i = kis.length - 1; i >= 0; i--) {
                    var kij = kis[i];
                    var pg = _.map(groups[kij], _.last);
                    var conds = _.map(pg, 'conditions')
                    var crit = _.first(pg).critical_point;
                    if (_.mean(conds) > crit) {
                        reaches.push(groups[kij]);
                    }
                }
            }
            return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
        },
        zones_pest_avgs_disaster() {
            var reaches = [];
            var reachedout = [];
            if (this.inspection.exceeded_individual_zones != undefined) {
                var groups = this.zones_groupped("avg");
                var kis = _.keys(groups)
                for (var i = kis.length - 1; i >= 0; i--) {
                    var kij = kis[i];
                    var pg = _.map(groups[kij], _.last);
                    var conds = _.map(pg, 'conditions')
                    var disaster = _.first(pg).disaster_point;
                    if (_.mean(conds) > disaster) {
                        reaches.push(groups[kij]);
                    }
                }
            }
            return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
        },
        zones_pest_meds_critical() {
            var reaches = [];
            var reachedout = [];
            if (this.inspection.exceeded_individual_zones != undefined) {
                var groups = this.zones_groupped("median");
                var kis = _.keys(groups)
                for (var i = kis.length - 1; i >= 0; i--) {
                    var kij = kis[i];
                    var pg = _.map(groups[kij], _.last);
                    var conds = _.map(pg, 'conditions')
                    var crit = _.first(pg).critical_point;
                    if (median(conds) > crit) {
                        reaches.push(groups[kij]);
                    }
                }
            }
            return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
        },
        zones_pest_meds_disaster() {
            var reaches = [];
            var reachedout = [];
            if (this.inspection.exceeded_individual_zones != undefined) {
                var groups = this.zones_groupped("median");
                var kis = _.keys(groups)
                for (var i = kis.length - 1; i >= 0; i--) {
                    var kij = kis[i];
                    var pg = _.map(groups[kij], _.last);
                    var conds = _.map(pg, 'conditions')
                    var disaster = _.first(pg).disaster_point;
                    if (median(conds) > disaster) {
                        reaches.push(groups[kij]);
                    }
                }
            }
            return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
        },
        zones_pest_maxes_critical() {
            var reaches = [];
            var reachedout = [];
            if (this.inspection.exceeded_individual_zones != undefined) {
                var groups = this.zones_groupped("max");
                var kis = _.keys(groups)
                for (var i = kis.length - 1; i >= 0; i--) {
                    var kij = kis[i];
                    var pg = _.map(groups[kij], _.last);
                    var conds = _.map(pg, 'conditions')
                    var crit = _.first(pg).critical_point;
                    for (var j = groups[kij].length - 1; j >= 0; j--) {
                        var grup = groups[kij][j]
                        if (grup[4].conditions > crit) {
                            reaches.push(grup);
                        }
                    }

                }
            }
            return Object.entries(_.groupBy(reaches, function(list) { return [list[0], list[1], list[2]].join(" / "); }));
        },
        zones_pest_maxes_disaster() {
            var reaches = [];
            var reachedout = [];
            if (this.inspection.exceeded_individual_zones != undefined) {
                var groups = this.zones_groupped("max");
                var kis = _.keys(groups)
                for (var i = kis.length - 1; i >= 0; i--) {
                    var kij = kis[i];
                    var pg = _.map(groups[kij], _.last);
                    var conds = _.map(pg, 'conditions')
                    var disaster = _.first(pg).disaster_point;
                    if (_.max(conds) > disaster) {
                        reaches.push(groups[kij]);
                    }
                }
            }
            return Object.entries(_.groupBy(_.flatten(reaches), function(list) { return [list[0], list[1], list[2]].join(" / "); }));
        }

    }

}
</script>
<style scoped>
.btn-large {
    border-radius: 8px;
    background-color: white;
    color: black;
    border-color: #00CC66;
    border-width: 1px;
    border-style: solid;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    height: 36px;
    line-height: 36px;
}

tr:last-child {
    border-bottom: none;
}

.addresses,
.addresses th,
.addresses td,
.properties,
.properties th,
.properties td {
    border: 1px solid rgba(0, 0, 0, 1);
    padding-left: 5px;
}

.properties,
.properties th,
.properties td {
    font-size: 10px;
    padding: 5px 5px;
    text-align: center;
}

tr>.current {
    border-left: 2px solid black;
}

tr>.current~.current {
    border: 1px solid rgba(0, 0, 0, 1);
}

.bolded-top {
    border-top: 2px solid black !important;
}

.bolded-left {
    border-left: 2px solid black !important;
}

.bolded-right {
    border-right: 2px solid black !important;
}

.bolded-bottom {
    border-bottom: 2px solid black !important;
}

tr:last-child>.current {
    border-bottom: 2px solid black !important;
}

th {
    border-bottom: 2px solid rgba(0, 0, 0, 0.12);
    font-weight: initial;
    padding-left: 0px;
}

td {
    padding-left: 0px;
}
td p {
    margin-top: 0px !important;
    margin-bottom: 0px !important;
}


.btn {
    margin-bottom: 5px;
}

.col p {
    margin: .7666666667rem 0 0.46rem 0;
}

.exceedvalues .col {
    line-height: 2;
}
.properties>tbody>tr:nth-of-type(odd) {
    background-color: rgba(0,0,0,0.05);
}
/deep/ .btn-small {
    margin: 15px !important;
    height: 36px !important;
    line-height: 36px !important;
}
</style>
